export const WorkstationReadRepositoryToken = Symbol('WorkstationReadRepository');
export const FallbackWorkstationRepositoryToken = Symbol('FallbackWorkstationRepository');
